import { uploadWorkbenchChunks } from './workbenchChunks'

export const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp']
export const documentExtensions = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf']
export const maxContentFileBytes = 20 * 1024 * 1024 * 1024

function videoDuration(file, signal) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file)
    const video = document.createElement('video')
    let settled = false
    const finish = (error, duration) => {
      if (settled) return
      settled = true
      clearTimeout(timer)
      if (signal) signal.removeEventListener('abort', abort)
      video.removeAttribute('src'); video.load(); URL.revokeObjectURL(url)
      error ? reject(error) : resolve(duration)
    }
    const abort = () => finish(Object.assign(new Error('已取消上传'), { cancelled: true }))
    const timer = setTimeout(() => finish(new Error('读取视频超时，请选择有效的 MP4 文件')), 30000)
    if (signal) { if (signal.aborted) { abort(); return }; signal.addEventListener('abort', abort, { once: true }) }
    video.preload = 'metadata'
    video.onloadedmetadata = () => finish(null, video.duration)
    video.onerror = () => finish(new Error('无法读取视频，请选择有效的 MP4 文件'))
    video.src = url
  })
}

export async function uploadWorkbenchMedia(http, file, allowed, onProgress = () => {}, contentType = '', options = {}) {
  const extension = (file.name.split('.').pop() || '').toLowerCase()
  if (!allowed.includes(extension)) throw new Error('文件格式不支持，请按提示选择文件')
  const limit = contentType === 'TEMPLATE' ? 200 * 1048576 : imageExtensions.includes(extension) ? 10 * 1048576 : maxContentFileBytes
  if (!file.size || file.size > limit) throw new Error('文件不能为空，且不能超过 ' + (limit === maxContentFileBytes ? '20 GB' : (limit / 1048576) + ' MB'))
  let durationSeconds = 0
  if (extension === 'mp4') {
    const duration = await videoDuration(file, options.signal)
    if (!Number.isFinite(duration) || duration <= 0) throw new Error('请选择有效的 MP4 视频')
    // 仅兼容现有INT元数据字段；文件不会因视频时长超过该范围而被拒绝。
    durationSeconds = Math.min(2147483647, Math.ceil(duration))
  }
  if (options.signal && options.signal.aborted) throw Object.assign(new Error('已取消上传'), { cancelled: true })
  if (contentType !== 'TEMPLATE' && file.size > 16 * 1048576) return uploadWorkbenchChunks(http, file, durationSeconds, onProgress, options.signal)
  const data = new FormData()
  data.append('file', file); data.append('durationSeconds', String(durationSeconds)); data.append('contentType', contentType)
  const response = await http.post('/oa/workbench/content/admin/media', data, {
    headers: { 'Content-Type': 'multipart/form-data', isLoading: false }, timeout: 1200000, signal: options.signal, workbenchUpload: true,
    onUploadProgress: e => { if (e.total) onProgress(Math.min(99, Math.floor(e.loaded * 100 / e.total))) }
  })
  if (!response || response.code !== 0 || !response.data || !response.data.url) throw new Error((response && response.message) || '上传失败，请重试')
  return response.data
}

export function plainToHtml(text) {
  return String(text || '').split('\n').map(line => '<p>' + line.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</p>').join('')
}
export function inlineUrls(html) {
  const doc = new DOMParser().parseFromString(html || '', 'text/html')
  return [...doc.querySelectorAll('img[src],video[src],source[src]')].map(node => node.getAttribute('src'))
}
